// content.js
const content = {
  hero: {
    name: "אהרון סגל",
    title: "מורה למוזיקה ומפיק",
    subtitle: "שיעורי גיטרה, פסנתר, יוקללי ופיתוח קול | הפקה מוזיקלית",
    logo: "%PUBLIC_URL%/images/segal_logo.png",
    image: "%PUBLIC_URL%/images/hero_image.jpg",
  },
  about: [
    {
      icon: "Music",
      text: "נולדתי ב-,1996 , נשוי +4, מנגן כל חיי על מגוון כלים ובעשור האחרון התחלתי ללמד מוזיקה ולהפיק שירים."
    },
    {
      icon: "Award",
      text: "בוא ללמוד גיטרה, פסנתר, יוקללי ופיתוח קול - מתאים לכל רמה בכל גיל לכל סגנון."
    },
    {
      icon: "Headphones",
      text: "יש לך שיר שאתה רוצה להפוך למציאות, הקלטה לאירוע או אפילו סתם לכיף,תוך מפגש מקצועי אחד תוכל להגשים חלום."
    },
    {
      icon: "Clock",
      text: "מלמד משעות הצהריים על חצות הלילה"
    },
    {
      icon: "BookOpen",
      text: "אני אוהב ללמד בצורה כיפית ודינמית, כאשר הלמידה משולבת בהקלטה של השיר הנלמד ובסיום כל תהליך תצא אם שיר שאתה ניגנת והקלטתה."
    },
    {
      icon: "Mic",
      text: "שיעורי פיתוח קול מותאמים לכל הרמות - בין אם אתה רוצה לשפר את השירה שלך או להיות זמר מקצועי."
    },
    {
      icon: "MessageSquare",
      text: "נלמד לדבר את שפת המוזיקה, כאשר המוזיקה היא השפה והכלי הוא רק אמצעי הביטוי."
    }
  ],
  music: [
    { 
      id: 1, 
      title: "Pheonix",
      url: "https://soundcloud.com/aharon-segal-408164914/pheonix"
    },
    { 
      id: 2, 
      title: "Ocean Panorama", 
      url: "https://soundcloud.com/aharon-segal-408164914/ocean-panorama"
    },
    { 
      id: 3, 
      title: "Hipster Blues", 
      url: "https://soundcloud.com/aharon-segal-408164914/hipster-blues-aharon-segal"
    }
  ],
  videos: [
    "https://www.youtube.com/embed/J2ingPVjWfI", 
    "https://www.youtube.com/embed/pC9Bt6sAlLw"
  ],
  contact: {
    email: "aharonsegalmusic@gmail.com",
    phone: "052-719-3536",
    address: "ברל כצנלסון, פתח תקווה"
  }
};

export default content;
